'use strict';

document.addEventListener('DOMContentLoaded', function() {

    const sp = document.querySelectorAll('.spImg');
    const pc = document.querySelectorAll('.pcImg');

    function isSmartPhone() {
            if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
                    pc.forEach(e => {
                        e.remove();
                    });
            } else {
                sp.forEach(e => {
                        e.remove();
                });
            }
    }
        isSmartPhone();
    });
   